import type { RentalsPaymentsPortalRouter } from '@src/backend/src/rentals/functions/paymentsPortal';
import { inferRouterOutputs } from '@trpc/server';
import type { PseBank } from '@src/backend/src/common/data/banks';

export type Invoices = inferRouterOutputs<RentalsPaymentsPortalRouter>['invoices']['list']['invoices'];

export type Invoice = Invoices[number];

export const invoiceReference = (invoice: { id: string; reference?: string }) => invoice.reference || invoice.id;

export type StatusMessage = NonNullable<Invoice['statusMessage']>;

export type DocumentType = Invoice['customerDocumentType'];
export const documentTypes = [
  'cc',
  'ce',
  'nit',
  'ti',
  'ps',
  'cif',
  'ne',
  'rc',
  'ppt',
] as const satisfies DocumentType[];
export const documentTypeNames = {
  cc: 'Cédula de Ciudadanía',
  ce: 'Cédula de Extranjería',
  nit: 'NIT',
  ti: 'Tarjeta de Identidad',
  ps: 'Pasaporte',
  cif: 'Código de Identificación Fiscal',
  ne: 'NIT Extranjero',
  rc: 'Registro Civil',
  ppt: 'Permiso de Permanencia Temporal',
} as const satisfies Record<(typeof documentTypes)[number], string>;

export type PaymentMethod = {
  id: 'pse' | 'card' | 'nequiButton' | 'bancolombiaButton' | 'breb' | 'cash';
  paymentMethod: string;
  imageUrl: string;
};

export type Merchant = {
  id: string;
  logoUrl: string;
};

export type PaymentInformation = {
  pseBank?: PseBank;
  name?: string;
  documentType?: 'cc' | 'ce' | 'nit' | 'ps';
  documentNumber?: string;
  email?: string;
  phoneNumber?: string;
  cardNumber?: string;
  cardExpDate?: string;
  cardCVC?: string;
  installments?: number;
  puntosColombiaDocumentType?: 'cc' | 'ce' | 'nit';
  puntosColombiaDocumentNumber?: string;
  okay: boolean;
};

export type Pay = {
  invoices: { id: string; paymentIsMinimum: boolean }[];
  payerInfo: {
    name: string;
    documentType: 'nit' | 'cc' | 'ce' | 'ps';
    documentNumber: string;
    email: string;
  };
  payment:
    | { type: 'pse'; bank: PseBank }
    | { type: 'nequiButton'; phoneNumber: string }
    | { type: 'bancolombiaButton' }
    | {
        type: 'card';
        card: {
          cardNumber: string;
          expirationMonth: string;
          expirationYear: string;
          cvv: string;
        };
      };
};
